<template>
  <div class="common-account-select-right">
    <div class="common-account-select-right-title">
      <span class="title-left">{{ title }}</span>
      <span class="title-right">{{ checkInfo }}</span>
    </div>
    <check-users-warp :check-list="checkList" />
    <slot name="check-users-operate" :disable="disable"></slot>
  </div>
</template>

<script>
import CheckUsersWarp from './CheckUsersWarp'
export default {
  name: 'AccountSelectItemShow',
  components: {
    CheckUsersWarp
  },
  props: {
    checkList: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: '发起群聊'
    }
  },
  data () {
    return {
    }
  },
  computed: {
    checkInfo () {
      return this.checkList.length === 0 ? '未选择联系人' : '已选择 '+ this.checkList.length +' 位联系人'
    },
    disable () {
      return this.title === '发起群聊' ? this.checkList.length < 2 : this.checkList.length < 1
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
.common-account-select-right {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 10px;
  background-color: #fff;
}
.common-account-select-right-title {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}
.title-right {
  font-size: 12px;
  color: #b2b2b2;
}
.check-users-operate {
  text-align: center;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/AccountSelectItemShow.vue